import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { ReportService } from "../../services/report.service";
import { NgxSpinnerService } from "ngx-spinner";
export interface Report_Data {
  name: string;
  description: string;
  fileName: string;
  report: number
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [DatePipe]
})
export class ReportsComponent implements OnInit {
  adminData: any;
  order_by = "created_dttm"; order = "DESC"
  reports: any = [];
  reports2: any = [];
  reports4: any = [];
  userStatus: any = ''; assessmentStatus: any = '';
  totle_request: any;
  online_active_time_spent: any = '';
  assesment_time_spent: any = '';
  start_date: any;
  login:any='-';

  startDate = new FormControl(new Date());
  endDate = new FormControl(new Date());


  report: Report_Data[] = [
    { name: 'Assessment Report', description: "This results at course and module level assessments attempted by the all the users can be reviewed here", fileName: 'Assessment report', report: 1 },
    { name: 'Manage Assessment Report', description: "This results assessments attempted by the all the users can be reviewed here", fileName: 'Manage Assessment Report', report: 5},
    { name: 'Course Report', description: "This report has all end to end information about the courses assigned to the users.", fileName: 'Course Report', report: 2 },
    { name: 'Organisation Reports', description: "The reports gives a view of the performance of the users at an organizational level", fileName: 'Organisation Report', report: 3 },
    { name: 'Last Login Report', description: "The reports gives a view of the performance of the user last login report", fileName: 'Last Login Report', report: 4 }

    // { name: 'Session Report', description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent laoreet sem eu pulvinar efficitur. Mauris quis ante ultrices, aliquet elit ut, scelerisque tellus. In sit amet velit odio. Donec fringilla massa eu tempor congue.", fileName: 'assets/downloads/KKmsdashboard.xlsx'},
  ]

  sortedData: Report_Data[];

  // report2: any = [{
  //   Course_name: 'Ramjee', Org: 'Partner.TechM-Noida.Voice', Active_users: 10, Inactive_Users: 11, Total_excl_inactive: 20, Completed: 10, Certified_Done: 5, Failed: 5,
  //   Not_completed: 2, Active_ongoing: 4, Certification: 3, Avg_quiz_score: 10
  // }];

  // report3: any = [{
  //   Course_Name: 'Ramjee', Module_Item_Name: 'module 1', No_of_users_assigned_to: 10, No_of_users_started: 5, No_of_users_completed: 5, No_of_users_in_progress: 4, First_Attempt_Passed_users: 4, First_attempt_Failed_users: 3,
  //   Average_Achieved_Score: 10, Total_users_passed: 5, Total_users_failed: 3, Online_Active_Time_Spent_minutes: 20, Org: "Partner.TechM-Noida.Voice"
  // }];

  // report4: any = [{
  //   Org: "Partner.TechM-Noida.Voice", Course_name: "Ramjee", Active_users: 10, Inactive_Users: 5, Total_excl_inactive: 5, Completed: 4, Certified_Done: 5, Failed: 1,
  //   Not_completed: 3, Active_ongoing: 2, Certification: 8, Avg_quiz_score: 10
  // }];

  constructor(private router: Router, private authReport: ReportService, private datePipe: DatePipe, private spinner: NgxSpinnerService) {
    this.sortedData = this.report.slice();
  }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
  }

  sortData(sort: Sort) {
    const data = this.report.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.name, b.name, isAsc);
        default: return 0;
      }
    });
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  logout() {

    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  // Excel download
  downloadsExcel(fileName: any, report: any, startDate: Date, endDate: Date) {
    if (report == 1) {
      this.spinner.show();
      this.authReport.assessmentReport(this.datePipe.transform(startDate, 'yyyy-MM-dd'), this.datePipe.transform(endDate, 'yyyy-MM-dd')).subscribe(
        (data) => {
          //console.log(data);
          this.reports = [];
          for (let i = 0; i < data.length; i++) {
            this.totle_request = 0;
            this.userStatus = ''; this.assessmentStatus = '';
            if (data[i].userdata.is_active == 1) {
              this.userStatus = "Active";
            } else { this.userStatus = "DeActive"; }
            if (data[i].is_passed == 1) {
              this.assessmentStatus = "Pass";
            } else { this.assessmentStatus = "Fail"; }
            if (data[i].start_dttm == null) {
              this.start_date = this.datePipe.transform(data[i].end_dttm, 'yyyy-MM-dd');
            } else {
              this.start_date = this.datePipe.transform(data[i].start_dttm, 'yyyy-MM-dd');
            }
            if (data[i].userdata != '' && data[i].userdata.course_module != '') {
              this.totle_request = data[i].userdata.reset_req_attempt * 3;
              this.reports.push({
                User_Id: data[i].userdata.email,
                User_Name: data[i].userdata.first_name + ' ' + data[i].userdata.last_name,
                Course_Name: data[i].userdata.Course,
                Module_Item_Name: data[i].userdata.course_module,
                SubModule_Item_Name: data[i].userdata.course_submodule,
                // Assigned_On: this.datePipe.transform(data[i].userdata.Assigned_On, 'yyyy-MM-dd'),
                Assigned_On: this.datePipe.transform(data[i].userdata.Assigned_On, 'yyyy-MM-dd'),
                //Started_On: this.datePipe.transform(data[i].userdata.Started_On, 'yyyy-MM-dd'),
                Started_On: this.start_date,
                // Started_On: this.datePipe.transform(data[i].start_dttm, 'yyyy-MM-dd'),
                Ended_Marked_On: this.datePipe.transform(data[i].end_dttm, 'yyyy-MM-dd'),
                // Last_Updated_On: '',
                Status: this.assessmentStatus,
                // Attempts:data[i].attempt_num,
                Attempts: data[i].attempt_num + this.totle_request,

                Achieved: '',
                Maximum_Score: data[i].userdata.Maximum_Score,
                Achieved_Score: data[i].userdata.Achived_Score,
                Pass: '',
                Online_Active_Time_Spent_minutes: data[i].time_spent,
                User_state: this.userStatus,
                Org: data[i].userdata.org_name
              })
            }
          }
          var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: true,
            title: '',
            useBom: true,
            noDownload: false,
            headers: ["User Id", "User Name", "Course Name", "Module/Item Name", "Submodule_Name", "Assigned On", "Started On", "Ended/Marked On",
              "Status", "Attempts", "Achieved %", "Maximum Score", "Achieved Score", "Pass %", "Online Active Time Spent (minutes)",
              "User state", "Org"]
          };
          new ngxCsv(this.reports, fileName, options);
          this.spinner.hide();
        }, (error) => {
          this.spinner.hide();
        },)
    } else if (report == 3) {
      this.spinner.show();
      this.authReport.organisationReport().subscribe(
        (data) => {
          console.log(data);
          this.reports2 = [];
          if (data.status == 200) {
            for (let j = 0; j < data.details.length; j++) {
              this.reports2.push({
                Org: data.details[j].org_name,
                Course_name: data.details[j].course_name,
                Active_users: data.details[j].active_user,
                Inactive_Users: data.details[j].not_active_user,
                Total_excl_inactive: data.details[j].total_user,
                Completed: data.details[j].course_completed_user,
                Not_completed: data.details[j].course__not_completed_user,
                Certified_Done: data.details[j].assesment_passed,
                Failed: data.details[j].assesment_failed,
                Active_ongoing: data.details[j].active_user_reading_course,
                Certification: '',
                Avg_quiz_score: data.details[j].avg_quiz_score.toFixed(2)
                //Avg_quiz_score: data.details[j].avg_quiz_score
              })
            }
            var options = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              title: '',
              useBom: true,
              noDownload: false,
              headers: ["Org", "Course name", "Active users", "Inactive Users", "Total", "Completed", "Not completed",
                "Certified/Done", "Failed", "Active ongoing", "Certification %", "Avg quiz score"]
            };
            new ngxCsv(this.reports2, fileName, options);
            this.spinner.hide();
          }
        }, (error) => {
          this.spinner.hide();
        })
    } else if (report == 2) {
      this.spinner.show();
      this.authReport.courseReport().subscribe(
        (data) => {
          this.reports2 = [];
          if (data.status == 200) {
            for (let k = 0; k < data.details.length; k++) {
              this.online_active_time_spent = '';
              this.assesment_time_spent = '';
              if (data.details[k].online_active_time_spent != null) {
                this.online_active_time_spent = data.details[k].online_active_time_spent;
              }
              if (data.details[k].assesment_time_spent != null) {
                this.assesment_time_spent = data.details[k].assesment_time_spent;
              }
              this.reports2.push({
                Org: data.details[k].org_name,
                Course_name: data.details[k].course_name,
                Module_Item_Name: data.details[k].module_name,
                No_of_users_assigned_to: data.details[k].active_user,
                No_of_users_started: data.details[k].user_started_module,
                No_of_users_completed: data.details[k].user_completed_course,
                No_of_users_in_progress: data.details[k].user_still_reading_course,
                First_Attempt_Passed_users: data.details[k].user_passed_first_attempt,
                First_attempt_Failed_users: data.details[k].user_failed_first_attempt,
                Average_Achieved_Score: parseFloat(data.details[k].avg_achieved_score).toFixed(0),
                //Average_Achieved_Score: data.details[k].avg_achieved_score,
                Total_users_passed: data.details[k].total_user_passed,
                Total_users_failed: data.details[k].total_user_failed,
                Online_Active_Time_Spent_minutes_reading: Math.floor(this.online_active_time_spent / 60),
                //Online_Active_Time_Spent_minutes_assessment:data.details[k].assesment_time_spent
                Online_Active_Time_Spent_minutes_assessment: Math.floor(this.assesment_time_spent / 60)
              })
            }
            var options = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              title: '',
              useBom: true,
              noDownload: false,
              headers: ["Org", "Course name", "Module/Item Name", "No. of users assigned to", "No. of users started", "No. of users completed", "No. of users in progress",
                "First Attempt Passed users", "First attempt Failed users", "Average Achieved Score", "Total users passed", "Total users failed", "Online Active Time Spent (minutes)- reading", "Online Active Time Spent (minutes)- assessment"]
            };
            new ngxCsv(this.reports2, fileName, options);
            this.spinner.hide();
          }
        }, (error) => {
          this.spinner.hide();
        })
    } else if (report == 4) {
      this.spinner.show();
      this.authReport.lastLoginRepost(this.adminData.user_id).subscribe(
        (data) => {
          this.reports4 = [];
          if (data.Status == 200) {
            console.log(data,'helllo');
            for (let k = 0; k < data.data.length; k++) {
              if(data.data[k].last_login == null){
               // this.login='-'
              }else{
              this.login =   this.datePipe.transform(data.data[k].last_login, 'YYYY-MM-dd h:mm:ss')
              }

              this.reports4.push({
                User_name: data.data[k].first_name,
                User_email: data.data[k].email,
                Last_login: this.login
              })
            }
              var options4 = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalseparator: '.',
                showLabels: true,
                showTitle: true,
                title: '',
                useBom: true,
                noDownload: false,
                headers: ["User name","User Email", "Last Login"]
              };
              new ngxCsv(this.reports4, fileName, options4);
              this.spinner.hide();
          }
        }, (error) => {
          this.spinner.hide();
        })
    } else if (report == 5) {
        this.spinner.show();
        this.authReport.seperateAssessmentReport(this.datePipe.transform(startDate, 'yyyy-MM-dd'), this.datePipe.transform(endDate, 'yyyy-MM-dd')).subscribe(
          (data) => {
            console.log(data);
            this.reports = [];
            for (let i = 0; i < data.length; i++) {
              this.totle_request = 0;
              this.userStatus = ''; this.assessmentStatus = '';
              if (data[i].userdata.is_active == 1) {
                this.userStatus = "Active";
              } else { this.userStatus = "DeActive"; }
              if (data[i].is_passed == 1) {
                this.assessmentStatus = "Pass";
              } else { this.assessmentStatus = "Fail"; }
              if (data[i].start_dttm == null) {
                this.start_date = this.datePipe.transform(data[i].end_dttm, 'yyyy-MM-dd');
              } else {
                this.start_date = this.datePipe.transform(data[i].start_dttm, 'yyyy-MM-dd');
              }
              if (data[i].userdata != '' && data[i].userdata.course_module != '') {
                this.totle_request = data[i].userdata.reset_req_attempt * 3;
                this.reports.push({
                  User_Id: data[i].userdata.email,
                  User_Name: data[i].userdata.first_name + ' ' + data[i].userdata.last_name,
                  Assessment_Name: data[i].userdata.assessment_name,
                //  Module_Item_Name: data[i].userdata.course_module,
                //  SubModule_Item_Name: data[i].userdata.course_submodule,

                  Assigned_On: this.datePipe.transform(data[i].userdata.Assigned_On, 'yyyy-MM-dd'),
                  Started_On: this.start_date,
                  Ended_Marked_On: this.datePipe.transform(data[i].end_dttm, 'yyyy-MM-dd'),
                  // Last_Updated_On: '',
                  Status: this.assessmentStatus,
                  // Attempts:data[i].attempt_num,
                  Attempts: data[i].attempt_num + this.totle_request,
                  Achieved: '',
                  Maximum_Score: data[i].userdata.Maximum_Score,
                  Achieved_Score: data[i].userdata.Achived_Score,
                  Pass: '',
                  Online_Active_Time_Spent_minutes: data[i].time_spent,
                  User_state: this.userStatus,
                  Org: data[i].userdata.org_name
                })
              }
            }
            var options = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              title: '',
              useBom: true,
              noDownload: false,
              headers: ["User Id", "User Name", "Assessment Name", "Assigned On", "Started On", "Ended/Marked On",
                "Status", "Attempts", "Achieved %", "Maximum Score", "Achieved Score", "Pass %", "Online Active Time Spent (minutes)",
                "User state", "Org"]
            };
            new ngxCsv(this.reports, fileName, options);
            this.spinner.hide();
          }, (error) => {
            this.spinner.hide();
          },)
    }
  }


}

